// 🌿 API Craft Back Office - Models Hook
import { useState, useEffect } from 'react';
import { DbModel } from '../types';
import { modelsApi } from '../services/api';

export const useModels = () => {
  const [models, setModels] = useState<DbModel[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchModels = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const userModels = await modelsApi.getUserModels();
      setModels(userModels || []);
    } catch (err: any) {
      const errorMessage = err.response?.data?.detail || err.message || 'Failed to fetch models';
      setError(errorMessage);
      setModels([]); // Set empty array on error
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchModels();
  }, []);

  const refreshModels = () => {

    fetchModels();
  };

  // Get model by name
  const getModelByName = (modelName: string): DbModel | undefined => {
    return models.find(model => model.model === modelName);
  };

  // Get models statistics
  const getModelsStats = () => {
    if (!models || models.length === 0) {
      return {
        totalModels: 0,
        totalFields: 0,
        averageFieldsPerModel: 0,
        uniqueFieldTypes: 0,
        fieldTypes: [],
      };
    }

    const totalFields = models.reduce((total, model) => 
      total + model.table_structure.fields.length, 0
    );
    
    const fieldTypes = models.flatMap(model => 
      model.table_structure.fields.map(field => field.type)
    );
    
    const uniqueFieldTypes = Array.from(new Set(fieldTypes));
    
    return {
      totalModels: models.length,
      totalFields,
      averageFieldsPerModel: models.length > 0 ? Math.round(totalFields / models.length) : 0,
      uniqueFieldTypes: uniqueFieldTypes.length,
      fieldTypes: uniqueFieldTypes,
    };
  };

  return {
    models,
    isLoading,
    error,
    refreshModels,
    getModelByName,
    getModelsStats,
  };
};
